import { ThemeProvider, Theme } from '@mui/material/styles';

import { useAppSelector } from './hooks';
import { brandingDarkTheme } from '../darkTheme';
import { Themes } from './appSlice';
import { brandingLightTheme } from '../lightTheme';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const CustomThemeProvider = ({ children }: Props) => {
  const { theme } = useAppSelector((state) => state.app);
  let muiTheme: Theme = brandingDarkTheme;

  if (theme === Themes.Dark) {
    muiTheme = brandingDarkTheme;
  } else {
    muiTheme = brandingLightTheme;
  }

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default CustomThemeProvider;
